import { createRoot } from 'react-dom/client'
import * as Sentry from '@sentry/react'
import App from './App.tsx'
import './index.css'

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: true,   // GDPR: dölj all text i replays
      blockAllMedia: true, // GDPR: blockera media
    }),
  ],
  tracesSampleRate: 0.1,          // Tracka 10% av requests
  replaysSessionSampleRate: 0,    // Ingen replay i normal drift
  replaysOnErrorSampleRate: 1.0,  // 100% replay vid errors
  beforeSend(event) {
    // GDPR: ta bort känslig användardata innan den skickas
    if (event.user) {
      delete event.user.email;
      delete event.user.username;
    }
    return event;
  },
});

createRoot(document.getElementById("root")!).render(<App />);
